const global = window;

inputs.alias.time = 'date';
inputs.alias.datetime = 'date';

// inputs.typesDelay.date = 1

inputs.fn.date = {
    configureDateMinMax(config, input, date, prop, inputWindow) {
        const momentDate = moment(date, 'YYYY-MM-DD', true);
        if (momentDate.isValid()) {
            config[`${prop}Date`] = momentDate.format('Y-m-d');
            data[prop] = null;
        } else {
            const inputTarget = inputWindow.find(`[data-name="${date}"]`);
            config[`${prop}Date`] = $(inputTarget).val() || false;
            inputTarget.change(function () {
                input.data('xdsoft_datetimepicker').setOptions({
                    [`${prop}Date`]: $(this).val() || false,
                });
            });
        }
    },
};

inputs.types.date = function (data, name, niceName, type, input, parent, inputWindow) {
    $.datetimepicker.setLocale('fr');

    const isDatetime = data.type === 'datetime';
    const darkTheme = (input.closest('.block--dark').length || window.darkTheme);
    let rawPeriod = data.period ||
        data.periodType ||
        data.mode ||
        data.unit ||
        data.select ||
        data.view ||
        data.step ||
        input.attr('data-period') ||
        input.attr('data-mode') ||
        input.data('period') ||
        input.data('mode') ||
        input.closest('.field--date-week, [data-period="week"], [data-mode="week"]').attr('data-period') ||
        input.closest('.field--date-month, [data-period="month"]').attr('data-period') ||
        input.closest('.field--date-year, [data-period="year"]').attr('data-period') ||
        (input.closest('.field--date-week, [data-mode="week"]').length ? 'week' : '') ||
        'date';
    if (typeof rawPeriod !== 'string') rawPeriod = String(rawPeriod || 'date');
    const period = rawPeriod.toLowerCase();
    const isWeek = period === 'week' || period === 'semaine';
    const isMonth = period === 'month' || period === 'mois';
    const isYear = period === 'year' || period === 'annee' || period === 'année';
    const periodType = isWeek ? 'week' : (isMonth ? 'month' : (isYear ? 'year' : 'date'));

    console.log('[Centrall Date Input Init]', {
        name: name,
        type: type,
        data: data,
        inputAttributes: {
            id: input.attr('id'),
            name: input.attr('name'),
            'data-period': input.attr('data-period'),
            'data-mode': input.attr('data-mode'),
            class: input.attr('class')
        },
        periodResolved: period,
        periodType: periodType,
        isWeek: isWeek
    });

    const qTransitionMonth = parseInt(data.quarterTransitionMonth || (data.quarterTransition && data.quarterTransition.month) || input.data('quarter-transition-month') || 1, 10);
    const qTransitionDay = parseInt(data.quarterTransitionDay || (data.quarterTransition && data.quarterTransition.day) || input.data('quarter-transition-day') || 1, 10);

    const getWeekBounds = function (m) {
        // Aligne avec la semaine Centrall (dimanche = 0)
        const dayOfWeek = m.day();
        const start = m.clone().subtract(dayOfWeek, 'days');
        const end = start.clone().add(6, 'days');
        return { start, end };
    };

    const formatWeekRange = function (start, end) {
        const days = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'];
        const months = ['Janv.', 'Fév.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];
        const dStart = (start.date() < 10 ? '0' : '') + start.date();
        const dEnd = (end.date() < 10 ? '0' : '') + end.date();
        const jStart = days[start.day()];
        const jEnd = days[end.day()];
        const mStart = months[start.month()];
        const mEnd = months[end.month()];
        const yStart = start.year();
        const yEnd = end.year();

        if (yStart === yEnd && mStart === mEnd) {
            return `${dStart} au ${dEnd} ${mStart} ${yStart}`;
        } else if (yStart === yEnd) {
            return `${dStart} ${mStart} au ${dEnd} ${mEnd} ${yStart}`;
        } else {
            return `${dStart} ${mStart} ${yStart} au ${dEnd} ${mEnd} ${yEnd}`;
        }
    };

    const showWeekNumber = (
        data.showWeekNumber !== undefined ? !!data.showWeekNumber :
        (data.showWeekNumbers !== undefined ? !!data.showWeekNumbers :
        (data.weeks !== undefined ? !!data.weeks :
        (input.data('show-week-number') !== undefined ? (input.data('show-week-number') === 1 || input.data('show-week-number') === '1' || input.data('show-week-number') === true) :
        false)))
    );

    const config = {
        lang: 'fr',
        format: `Y-m-d${isDatetime ? ' H:i' : ''}`,
        allowBlank: true,
        timepicker: isDatetime && periodType === 'date',
        inline: data.inline,
        theme: darkTheme ? 'dark' : 'default',
        trigger: data.trigger,
        showWeekNumber: showWeekNumber, // Option désactivée par défaut dans date.js
        showWeekNumbers: showWeekNumber,
        weeks: showWeekNumber, // Désactivé par défaut (false)
        periodType: periodType,
        quarterTransitionMonth: qTransitionMonth,
        quarterTransitionDay: qTransitionDay,
    };
    if (data.quarterTransition) config.quarterTransition = data.quarterTransition;
    if (periodType === 'week') {
        config.dayOfWeekStart = 0;
        config.closeOnDateSelect = true;
        config.onSelectDate = function (ct, $i) {
            console.log('[Centrall Date onSelectDate]', { ct, periodType });
            const m = moment(ct);
            const bounds = getWeekBounds(m);
            const wStart = bounds.start.format('YYYY-MM-DD');
            if ($i.val() !== wStart) {
                $i.val(wStart);
            }
            $i.trigger('change');
        };
    } else if (periodType === 'month') {
        config.closeOnDateSelect = true;
        config.onSelectDate = function (ct, $i) {
            console.log('[Centrall Date onSelectDate - month]', { ct, periodType });
            const m = moment(ct);
            const mStart = m.format('YYYY-MM-01');
            if ($i.val() !== mStart) {
                $i.val(mStart);
            }
            $i.trigger('change');
        };
    } else if (periodType === 'year') {
        config.closeOnDateSelect = true;
        config.onSelectDate = function (ct, $i) {
            console.log('[Centrall Date onSelectDate - year]', { ct, periodType });
            const m = moment(ct);
            const yStart = m.format('YYYY-MM-DD');
            if ($i.val() !== yStart) {
                $i.val(yStart);
            }
            $i.trigger('change');
        };
    }

    config.onGenerate = function (ct, $i) {
        console.log('[Centrall Date onGenerate]', {
            ct: ct,
            inputVal: $i ? $i.val() : null,
            periodType: periodType,
            isWeek: isWeek
        });
        if (isWeek) {
            const picker = $(this);
            picker.addClass('xdsoft_weekpicker xdsoft_period_week');
            if (showWeekNumber) {
                picker.addClass('xdsoft_showweeks');
            } else {
                picker.removeClass('xdsoft_showweeks');
            }
            const val = $i ? $i.val() : null;
            const m = val ? moment(val, ['YYYY-MM-DD', 'YYYY/MM/DD'], true) : (ct ? moment(ct) : moment());
            if (m.isValid()) {
                const bounds = getWeekBounds(m);
                const selStart = bounds.start.clone().startOf('day');
                const selEnd = bounds.end.clone().endOf('day');
                picker.find('tbody tr').each(function () {
                    const tr = $(this);
                    let isRowCurrent = false;
                    tr.find('td.xdsoft_date').each(function () {
                        const td = $(this);
                        const d = parseInt(td.data('date'), 10);
                        const mo = parseInt(td.data('month'), 10);
                        const y = parseInt(td.data('year'), 10);
                        const dayMoment = moment([y, mo, d]);
                        if (dayMoment.isBetween(selStart, selEnd, null, '[]')) {
                            td.addClass('xdsoft_current xdsoft_week_selected');
                            isRowCurrent = true;
                        }
                    });
                    if (isRowCurrent) {
                        tr.addClass('xdsoft_current_week');
                        tr.find('th.xdsoft_week').addClass('xdsoft_current_week');
                    }
                });
            }
        }
    };

    if (data.min) {
        inputs.fn.date.configureDateMinMax(config, input, data.min, 'min', inputWindow);
    }

    if (data.max) {
        inputs.fn.date.configureDateMinMax(config, input, data.max, 'max', inputWindow);
    }

    input.datetimepicker(config);

    if (isWeek) {
        const dp = input.data('xdsoft_datetimepicker');
        if (dp) {
            dp.addClass('xdsoft_weekpicker xdsoft_period_week');
            if (showWeekNumber) {
                dp.addClass('xdsoft_showweeks');
            } else {
                dp.removeClass('xdsoft_showweeks');
            }
        }
    }

    if (isWeek && !window.xdsoftWeekpickerEventsInitialized) {
        window.xdsoftWeekpickerEventsInitialized = true;
        $(document)
            .on('mouseenter.xdsoft_week', '.xdsoft_weekpicker tbody tr, .xdsoft_period_week tbody tr, .xdsoft_showweeks tbody tr', function () {
                $(this).find('td.xdsoft_date:not(.xdsoft_disabled)').addClass('xdsoft_week_hover');
                $(this).find('th.xdsoft_week').addClass('xdsoft_week_hover');
            })
            .on('mouseleave.xdsoft_week', '.xdsoft_weekpicker tbody tr, .xdsoft_period_week tbody tr, .xdsoft_showweeks tbody tr', function () {
                $(this).find('td.xdsoft_date').removeClass('xdsoft_week_hover');
                $(this).find('th.xdsoft_week').removeClass('xdsoft_week_hover');
            })
            .on('click.xdsoft_week_num', '.xdsoft_weekpicker th.xdsoft_week, .xdsoft_weekpicker td.xdsoft_week, .xdsoft_period_week th.xdsoft_week, .xdsoft_period_week td.xdsoft_week, .xdsoft_showweeks th.xdsoft_week, .xdsoft_showweeks td.xdsoft_week', function () {
                const target = $(this).siblings('td.xdsoft_date:not(.xdsoft_other_month)').first();
                if (target.length) {
                    target.trigger('click');
                } else {
                    $(this).siblings('td.xdsoft_date').first().trigger('click');
                }
            });
    }

    // Layout avec fleches (arrows)
    const wrap = input.closest('.field--date-arrows, .calendrierPicker');
    if (wrap.length) {
        const updateDateText = function () {
            const val = input.val();
            if (!val) return;
            const m = moment(val, 'YYYY-MM-DD');
            if (!m.isValid()) return;

            const days = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'];
            const months = ['Janv.', 'Fév.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];
            const monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

            if (isWeek) {
                const bounds = getWeekBounds(m);
                wrap.find('.dateAffiche, .field__date-text').text(formatWeekRange(bounds.start, bounds.end));
            } else if (isMonth) {
                wrap.find('.dateAffiche, .field__date-text').text(`${monthsFull[m.month()]} ${m.year()}`);
            } else if (isYear) {
                let y = m.year();
                const month = m.month() + 1;
                const day = m.date();
                if (month < qTransitionMonth || (month === qTransitionMonth && day < qTransitionDay)) {
                    y--;
                }
                if (qTransitionMonth === 1 && qTransitionDay === 1) {
                    wrap.find('.dateAffiche, .field__date-text').text(`Année ${y}`);
                } else {
                    wrap.find('.dateAffiche, .field__date-text').text(`Année ${y}-${y + 1}`);
                }
            } else {
                const d = m.date();
                const dayPad = (d < 10 ? '0' : '') + d;
                const text = `${days[m.day()]}, ${dayPad} ${months[m.month()]} ${m.year()}`;
                wrap.find('.dateAffiche, .field__date-text').text(text);
            }
        };

        wrap.find('.flecheGauche, .icon-before').off('click.arrows').on('click.arrows', function (e) {
            e.preventDefault();
            const curVal = input.val() || moment().format('YYYY-MM-DD');
            const m = moment(curVal, 'YYYY-MM-DD');
            if (isWeek) {
                const bounds = getWeekBounds(m);
                const prev = bounds.start.subtract(7, 'days');
                input.val(prev.format('YYYY-MM-DD')).trigger('change');
            } else if (isMonth) {
                m.subtract(1, 'month').date(1);
                input.val(m.format('YYYY-MM-DD')).trigger('change');
            } else if (isYear) {
                m.subtract(1, 'year');
                input.val(m.format('YYYY-MM-DD')).trigger('change');
            } else {
                m.subtract(1, 'days');
                input.val(m.format('YYYY-MM-DD')).trigger('change');
            }
        });

        wrap.find('.flecheDroite, .icon-after').off('click.arrows').on('click.arrows', function (e) {
            e.preventDefault();
            const curVal = input.val() || moment().format('YYYY-MM-DD');
            const m = moment(curVal, 'YYYY-MM-DD');
            if (isWeek) {
                const bounds = getWeekBounds(m);
                const next = bounds.start.add(7, 'days');
                input.val(next.format('YYYY-MM-DD')).trigger('change');
            } else if (isMonth) {
                m.add(1, 'month').date(1);
                input.val(m.format('YYYY-MM-DD')).trigger('change');
            } else if (isYear) {
                m.add(1, 'year');
                input.val(m.format('YYYY-MM-DD')).trigger('change');
            } else {
                m.add(1, 'days');
                input.val(m.format('YYYY-MM-DD')).trigger('change');
            }
        });

        wrap.find('.dateTrigger, .icon-calendar').off('click.arrows').on('click.arrows', function (e) {
            e.preventDefault();
            input.datetimepicker('show');
        });

        input.on('change.arrows', updateDateText);
    } else if (periodType !== 'date') {
        input.on('change.period_snap', function () {
            const val = input.val();
            if (!val) return;
            const m = moment(val, ['YYYY-MM-DD', 'YYYY/MM/DD', 'DD/MM/YYYY'], false);
            if (m.isValid()) {
                if (isWeek) {
                    const bounds = getWeekBounds(m);
                    const startStr = bounds.start.format('YYYY-MM-DD');
                    if (val !== startStr) {
                        input.val(startStr);
                    }
                    input.attr('title', formatWeekRange(bounds.start, bounds.end));
                } else if (isMonth) {
                    const startStr = m.format('YYYY-MM-01');
                    if (val !== startStr) {
                        input.val(startStr);
                    }
                }
            }
        });
        if (input.val()) {
            const m = moment(input.val(), 'YYYY-MM-DD');
            if (m.isValid()) {
                if (isWeek) {
                    const bounds = getWeekBounds(m);
                    input.attr('title', formatWeekRange(bounds.start, bounds.end));
                }
            }
        }
    }

    // Gestion du Copier / Couper / Coller
    input.on('keydown', function (e) {
        if (e.ctrlKey || e.metaKey) {
            const key = e.key.toLowerCase();
            if (key === 'c' || key === 'x') {
                const val = input.val();
                let toCopy = val;

                if (val) {
                    const m = moment(val, [
                        'YYYY-MM-DD HH:mm',
                        'YYYY-MM-DD',
                        'DD/MM/YYYY HH:mm',
                        'DD/MM/YYYY',
                        'YYYY/MM/DD HH:mm',
                        'YYYY/MM/DD',
                    ], false);

                    if (m.isValid()) {
                        toCopy = m.format('YYYY-MM-DD HH:mm');
                    }
                }

                clipboardCopy(toCopy, true);
                if (key === 'x') {
                    input.val('');
                    input.trigger('change');
                }
            }
        }
    });

    input.on('paste', function (e) {
        const clipboardData = (e.originalEvent || e).clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('text');

        if (pastedData) {
            const m = moment(pastedData, [
                'YYYY-MM-DD HH:mm',
                'YYYY-MM-DD',
                'DD/MM/YYYY HH:mm',
                'DD/MM/YYYY',
                'YYYY/MM/DD HH:mm',
                'YYYY/MM/DD',
            ], false);

            if (m.isValid()) {
                e.preventDefault();
                input.val(m.format(`YYYY-MM-DD${isDatetime ? ' HH:mm' : ''}`));
                input.trigger('change');
            }
        }
    });

    return data;
};
